import React from "react";
import PT from "prop-types";
import * as S from "./styled";
import TextInput from "_c/form/TextInput";
import Select from "_c/Select";
import { ORDERS_NS } from "@/i18n/ns";
import TextSearch from "../";

const DesktopTextSearch = ({ t, ...props }) => {
  return (
    <TextSearch updateQuery={props.updateQuery} query={props.query} t={t}>
      {({ search, searchBy, changeSearch, changeSearchBy, searchOptions }) => (
        <S.Wrap>
          <TextInput
            value={search}
            onChange={changeSearch}
            placeholder={t(`${ORDERS_NS}:search.text.query_label`)}
          />
          <Select
            value={searchBy}
            onChange={changeSearchBy}
            placeholder={t(`${ORDERS_NS}:search.text.type_label`)}
            isClearable
            isSearchable={false}
            options={searchOptions}
          />
        </S.Wrap>
      )}
    </TextSearch>
  );
};
DesktopTextSearch.propTypes = {
  query: PT.object.isRequired,

  updateQuery: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default DesktopTextSearch;
